import React from "react"
import Image from "gatsby-image"

export default (props) => <Image {...props} />
